var _a;
import TokenService from "shared/api/token-service";
import { io } from "socket.io-client";
var SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
var SOCKET_PATH = process.env.REACT_APP_SOCKET_PATH;
export var socket = io(SOCKET_URL, {
    path: SOCKET_PATH,
    auth: {
        token: (_a = TokenService.getAccessToken()) !== null && _a !== void 0 ? _a : "",
    },
    autoConnect: false,
    transports: ["websocket"],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 500,
    reconnectionDelayMax: 8000,
});
export var syncSocketAuthToken = function () {
    var _a;
    socket.auth = {
        token: (_a = TokenService.getAccessToken()) !== null && _a !== void 0 ? _a : "",
    };
};
socket.on("connect", function () { return console.log("socket connect"); });
socket.on("disconnect", function () { return console.log("socket disconnect"); });
